import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import styled, { css } from "react-emotion";
import Pagination from "@material-ui/lab/Pagination";
import { getUsersWhoDownloadedApp } from "apis";
import CountUp from "react-countup";
import { withRedux, isMobileDevice } from "helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FlexRow, H1 } from "appStyles";

const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: "white";
  display: block;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`;

const GreySpan = styled("span")`
  color: rgb(158, 158, 158);
  font-size: 0.75rem;
`;

const GreenSpan = styled("span")`
  color: #89d2d3;
`;
const RedSpan = styled("span")`
  color: #f17f7f;
`;

const arrowContainer = css`
  margin: 0px 20px;
  @media only screen and (min-width: 768px) {
    margin: 0px 40px;
  }
`;

const arrowStyle = css`
  font-size: 1.3em;
  display: flex;
  align-self: flex-end;
  margin-top: 10px;
  margin-bottom: 10px;
  @media only screen and (min-width: 768px) {
    font-size: 2em;
    cursor: pointer;
    display: flex;
    align-self: flex-end;
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;

const AnalyticContainer = styled("div")`
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  text-align: center;
  padding: 15px;
  width: fit-content;
  background: white;
  color: black;
  box-shadow: 3px 3px 13px rgb(120 120 120 / 50%);
`;

const headerText = css`
  text-align: center;
  font-size: 1.2em;
  margin: 0px;
  @media only screen and (min-width: 768px) {
    text-align: center;
    font-size: 1.5em;
    margin: 0px;
  }
`;

const headerContainer = css`
  height: 25px;
  align-items: center;
  margin: 10px 0px;
  justify-content: center;
  @media only screen and (min-width: 768px) {
    height: 25px;
    align-items: center;
    margin: 20px 0px;
    justify-content: center;
  }
`;

function parseQuery(queryString) {
  var query = {};
  var pairs = (
    queryString[0] === "?" ? queryString.substr(1) : queryString
  ).split("&");
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split("=");
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
  }
  return query;
}

const isMob = isMobileDevice();

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginTop: theme.spacing(2),
    boxShadow: "none",
  },
  table: {
    maxWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  MuiSvgIcon: {
    fontSize: "1.15rem",
  },
  paginationSpacer: {
    flex: "none",
  },
  paginationToolbar: {
    justifyContent: !isMob ? "center" : "unset",
  },
  MuiTableCell: {
    letterSpacing: 0,
    overflowWrap: "anywhere",
  },
}));

const Customers = (props) => {
  const {
    platformInfo: { status: user },
  } = props;

  const [usersInfoObject, setUserInfoObject] = useState({});
  const classes = useStyles();
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(10);
  const [totalUsers, setTotalUsers] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");

  const [usersPerPage, setUsersPerPage] = useState(100);
  let pageNumber = page + 1;
  // console.log("On page: " + pageNumber);
  // console.dir(usersInfoObject);
  // console.log("Users for this page: ");
  // console.dir(users);
  const { guestUserCount } = usersInfoObject;

  useEffect(() => {
    getUsers();
  }, [usersPerPage, page]);

  const goBack = () => {
    props.history.push("/application");
  };

  const EnhancedTableHead = (props) => {
    return (
      <TableHead>
        <TableRow
          style={{
            textAlign: "left",
            borderBottom: "1pt solid black",
            backgroundColor: "#89d2d3",
            color: "white",
          }}
        >
          {" "}
          <TableCell
            style={{ lineHeight: "0.5em" }}
            className={classes.MuiTableCell}
          >
            <span
              style={{
                padding: "0px 0px",
                fontSize: "18px",
                fontWeight: "bold",
                color: "white",
              }}
            >
              User Info
            </span>
          </TableCell>
          <TableCell
            style={{ lineHeight: "0.5em" }}
            className={classes.MuiTableCell}
          >
            <span
              style={{
                padding: "0px 0px",
                fontSize: "18px",
                fontWeight: "bold",
                color: "white",
              }}
            >
              App Info
            </span>
          </TableCell>
        </TableRow>
      </TableHead>
    );
  };

  const getUsers = async () => {
    const path = props.history.location.pathname;
    const appId = path.substring(1, path.lastIndexOf("/customers"));
    let accessToken = null;
    if (!user.user) {
      const query = parseQuery(props.history.location.search);
      accessToken = query.accessCode;
    }
    try {
      const usersInfoObject = await getUsersWhoDownloadedApp(
        appId,
        page,
        usersPerPage,
        accessToken
      );
      // console.log("GOT USERS INFO OBJECT: ");
      // console.dir(usersInfoObject);
      setUserInfoObject(usersInfoObject);
      setUsers(usersInfoObject.content);
      setTotalUsers(usersInfoObject.totalElements);
      setPage(usersInfoObject.currentPage);

      setTotalPages(usersInfoObject.totalPages);

      return usersInfoObject;
    } catch (e) {
      console.error(e);
    }
  };

  const handleChangePage = (event, newPage) => {
    let offByOne = newPage - 1;
    // console.log("setting new page to: " + offByOne);
    setPage(newPage - 1);
  };
  const handleTableChangePage = (event, newPage) => {
    // console.log("setting new page to: " + newPage);
    setPage(newPage);
  };

  const handleChangeUsersPerPage = (event) => {
    setUsersPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  String.prototype.toProperCase = function () {
    if (this != "IOS")
      return this.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    else return this;
  };

  const emptyRows =
    usersPerPage - Math.min(usersPerPage, users.length - page * usersPerPage);

  // console.log("table pagination reading page: " + page);

  const RenderUsers = () => {
    return (
      <TableBody>
        {users.slice(0, usersPerPage).map((user, index) => {
          const {
            userId,
            downloadDate,
            firstName,
            lastName,
            email,
            phoneNumber,
            systemNotificationOn,
            appNotificationOn,
            platformType,
            favorited,
          } = user;
          const parsedDownloadDate = new Date(downloadDate).toLocaleDateString(
            "en-US"
          );

          return (
            <TableRow
              hover
              onClick={(event) => handleClick(event, userId)}
              role="checkbox"
              tabIndex={-1}
              key={userId}
            >
              <TableCell width="50%" className={classes.MuiTableCell}>
                {firstName ? firstName : null} {lastName ? lastName : null}
                {(firstName || lastName) && <br />}
                {email ? (
                  <a
                    href={"mailto:" + email}
                    style={{
                      color: "black",
                    }}
                  >
                    {email}
                  </a>
                ) : null}
                {email && <br />}
                {phoneNumber ? (
                  <a
                    style={{
                      color: "black",
                    }}
                    href={"tel:" + phoneNumber}
                  >
                    {phoneNumber}
                  </a>
                ) : null}
              </TableCell>
              <TableCell width="50%" className={classes.MuiTableCell}>
                {downloadDate ? (
                  <span>Downloaded: {parsedDownloadDate}</span>
                ) : null}
                {downloadDate && <br />}

                {appNotificationOn ? (
                  <span>Notifications: On</span>
                ) : (
                  <span>Notifications: Off</span>
                )}
                <br />
                {platformType ? (
                  <span>Platform: {platformType.toProperCase()}</span>
                ) : null}
                <br />
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  };

  const getTotalUsers = () => {
    if (!guestUserCount || !totalUsers) {
      return 0;
    }
    return guestUserCount + totalUsers;
  };

  return (
    <div className={classes.root}>
      {user.user && (
        <div className={arrowContainer}>
          <FontAwesomeIcon
            className={arrowStyle}
            icon="arrow-left"
            onClick={goBack}
          />
        </div>
      )}

      <Paper className={classes.paper}>
        <FlexRow className={headerContainer}>
          <H1 className={headerText}>User Analytics</H1>
        </FlexRow>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <AnalyticContainer>
            Guest Users: <CountUp end={guestUserCount ? guestUserCount : 0} />
            <br />
            Registered Users: <CountUp end={totalUsers ? totalUsers : 0} />
            <br />
            Total Users: <CountUp end={getTotalUsers()} />
            {}
          </AnalyticContainer>
        </div>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={totalUsers}
          rowsPerPage={usersPerPage}
          page={page}
          onChangePage={handleTableChangePage}
          onChangeRowsPerPage={handleChangeUsersPerPage}
          classes={{
            spacer: classes.paginationSpacer,
            toolbar: classes.paginationToolbar,
          }}
        />

        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={"medium"}
            aria-label="enhanced table"
            style={{
              borderCollapse: "collapse",
              margin: "auto",
              tableLayout: "fixed",
            }}
          >
            <EnhancedTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              rowCount={users.length}
            />
            {RenderUsers()}
          </Table>
        </TableContainer>
        <div
          style={{ display: "flex", justifyContent: "center", margin: "1em" }}
        >
          <Pagination
            count={totalPages}
            color="primary"
            variant="outlined"
            shape="rounded"
            size="medium"
            showFirstButton
            showLastButton
            page={page + 1}
            onChange={handleChangePage}
          />
        </div>
      </Paper>
    </div>
  );
};

export default withRedux(Customers);
